import React, { useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import { StyledButton } from "../StyledComponents";
import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import SectionTextForm from "./SectionTextForm";
import SectionImagesForm from "./SectionImagesForm";
import SectionScaffold from "./SectionScaffold";

export default function AddSection({ token }) {
  const { locationId } = useParams();
  const navigate = useNavigate();
  const [values, setValues] = useState({
    title: "",
    subtitle: "",
    text: "",
    priority: "",
  });
  const [images, setImages] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);

  const queryClient = useQueryClient();

  const addSection = useMutation(
    () => {
      const headers = {
        Accept: "*/*",
        token: token.token,
        "Content-Type": "multipart/form-data",
      };

      const formData = new FormData();

      images.forEach((image, i) => {
        formData.append("pics", image.file);
      });

      formData.append(
        "data",
        JSON.stringify({
          locationId,
          title: values.title || null,
          subtitle: values.subtitle || null,
          text: values.text || null,
          priority: values.priority ? parseInt(values.priority, 10) : null,
        })
      );

      return axios.post(
        `${process.env.REACT_APP_BASE_URL}:${process.env.REACT_APP_ADMIN_PORT}/sections/create_section`,
        formData,
        { headers }
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["sections-get"]);
        setShowSuccess(true);
        setValues({ title: "", subtitle: "", text: "", priority: "" });
        setImages([]);
      },
    }
  );

  const handleCloseSuccess = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setShowSuccess(false);
    navigate(-1);
  };

  const handleDiscard = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <>
      <SectionScaffold
        title="Upload your new Section"
        cancelText="Cancel Creation"
        onCancel={handleDiscard}
        topChildren={<SectionTextForm values={values} setValues={setValues} />}
        bottomChildren={
          <SectionImagesForm images={images} setImages={setImages} />
        }
        footer={
          addSection.isLoading ? (
            <CircularProgress sx={{ color: "#1EABF1" }} />
          ) : (
            <StyledButton
              variant="contained"
              size="large"
              width="30%"
              disabled={!values.title}
              onClick={() => addSection.mutate()}
              myColor="#1EABF1"
              hoverColor="#187DDA"
            >
              Create Section on Join
            </StyledButton>
          )
        }
        footerNote="You may edit this Section's details at all times"
      />
      <Snackbar
        open={addSection.isError}
        autoHideDuration={2000}
        onClose={() => addSection.reset()}
      >
        <Alert
          onClose={() => addSection.reset()}
          severity="error"
          sx={{ width: "100%" }}
        >
          An error occured!
        </Alert>
      </Snackbar>
      <Snackbar
        open={showSuccess}
        autoHideDuration={2000}
        onClose={handleCloseSuccess}
      >
        <Alert
          onClose={handleCloseSuccess}
          severity="success"
          sx={{ width: "100%" }}
        >
          Section added successfully!
        </Alert>
      </Snackbar>
    </>
  );
}
